<div>
	<div class="top-section">
		<div class="card-button-group">
			<button class="button-general" [disabled]="parseDisabled" (click)="parse()">Parse</button>
			<button class="button-general" [disabled]="saveParseDisabled" (click)="saveParseResult()">Save Parsing Result</button>
			<button class="button-general" [disabled]="commitDisabled" (click)="commit()">Commit</button>
		</div>
	</div>
	<!-- <div class="content-section">
		<div class="filter-types">
			<div class="filter-type-item" *ngFor="let filterType of filterTypes">
				<input name="filter-type" type="radio" [(ngModel)]="selectedFilterType" [value]="filterType">
				<label>{{filterType.label}}: {{filterType.count}}</label>
			</div >
		</div>
	</div> -->
	<div>
		<app-a3i-edit-card #editCard></app-a3i-edit-card>
	</div>
</div>